// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { FormFieldIcon } from "@awc/MobiusOverrides/FormField";
import { searchInputStyles } from "@awc/Overrides/Widgets/Header/SearchInput";
import Search from "@awc/XDL/Icons/Search";
import { color, getInputStyleWithIcon, getSystemColor, styledScrollbar, xScreen } from "@awc/XDL/Utilities";
import { css } from "styled-components";


searchInputStyles.input = {
    ...getInputStyleWithIcon(),
};


searchInputStyles.floatingTooltip = {
    tooltipContent: {
        css: css`
            padding: 0;
            &:empty {
                border: none;
                display: none;
            }
        
        `,
    },
};

